/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Add_Card_TitleInputs */

const en_plan_add_card_title = /** @type {(inputs: Plan_Add_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a card`)
};

const es_plan_add_card_title = /** @type {(inputs: Plan_Add_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade una tarjeta`)
};

/**
* | output |
* | --- |
* | "Add a card" |
*
* @param {Plan_Add_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_add_card_title = /** @type {((inputs?: Plan_Add_Card_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Add_Card_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_add_card_title(inputs)
	return en_plan_add_card_title(inputs)
});